import * as Dialog from '@radix-ui/react-dialog'
import { IconButton } from '~/shared/ui/icon-button'
import { Tooltip } from '~/shared/ui/local-tooltip'
import { PDFContent } from './pdf-content'

interface FullScreenPDFDialogProps {
  open: boolean
  onClose: () => void
  file: string | null
  startPage?: number
  endPage?: number
  onDownload?: () => void
  onOpenInNewTab?: () => void
  initialFitToWidth?: boolean
  rotation?: {
    getRotation: (pageNumber: number) => number
    rotateLeft: (pageNumber: number) => void
    rotateRight: (pageNumber: number) => void
  }
}

export function FullScreenPDFDialog({
  open,
  onClose,
  file,
  startPage,
  endPage,
  onDownload,
  onOpenInNewTab,
  initialFitToWidth,
  rotation,
}: FullScreenPDFDialogProps) {
  return (
    <Dialog.Root
      open={open}
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay className="bg-surface-lowest fixed inset-0 z-10" />
        <Dialog.Content
          className="bg-surface-lowest fixed inset-0 z-11 m-0 h-screen max-h-screen w-screen max-w-screen overflow-hidden rounded-none px-6 pt-16 pb-6 focus:outline-none"
          onOpenAutoFocus={(e) => e.preventDefault()}
        >
          <Dialog.Title className="hidden">PDF Viewer</Dialog.Title>
          <div className="absolute top-4 right-6 z-10">
            <Tooltip
              content="Close"
              sideOffset={4}
              disableHoverableContent
            >
              <IconButton
                size="medium"
                container="small"
                materialIcon="close"
                onClick={onClose}
              />
            </Tooltip>
          </div>
          <PDFContent
            className="h-[calc(100dvh-64px-24px)]"
            file={file}
            startPage={startPage}
            endPage={endPage}
            onDownload={onDownload}
            onOpenInNewTab={onOpenInNewTab}
            initialFitToWidth={initialFitToWidth}
            onMinimizeContent={onClose}
            rotation={rotation}
          />
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
